import { render, staticRenderFns } from "./VaultDetails.vue?vue&type=template&id=f2a8ceba"
import script from "./VaultDetails.vue?vue&type=script&lang=js"
export * from "./VaultDetails.vue?vue&type=script&lang=js"
import style0 from "./VaultDetails.vue?vue&type=style&index=0&id=f2a8ceba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports